
import React, { useState, useEffect } from 'react';
import BZCarousel from 'web-common/bizzabo-components/components/BZCarousel';
import moment from 'moment';
import cn from 'classnames';
import { LeftArrowIcon } from '@bizzabo/icons';
import JoinLiveSessionButton from '../../JoinLiveSessionButton';
import { isSessionEnded, isSessionEndsInMoreThan, isSessionStartsInMorethan, useInterval } from '../../sessionBroadcastUtils';
import { setVirtualSessionDetails } from '../../../../../actions/SessionActions';

const NEXT_SESSION_BANNER_THRESHOLD = 4; // 4 minutes before session end, show next session banner
const NEXT_SESSIONS_COUNT = 9;
const NEXT_SESSION_STATUS_UPDATE_INTERVAL = 10000;
const SESSION_UPDATE_INTERVAL = 1000;
export const NEXT_SESSION_TIME_RANGE = 5 * 60 * 1000; // 5 minutes between sessions to be considered an upcoming one

const Arrow = (props) => {
    const { className, onClick, mirror } = props;
    return (
        <div
            className={cn('custom-color color-1 arrow-container', className)}
            onClick={onClick}
        >
            <i className={cn('fa icon-AgendaAtt_arrow arrow', { mirror })}/>
        </div>
    );
};

const getSliderSettings = (itemsCount) => ({
    slidesToShow: 1,
    infinite: itemsCount > 1,
    prevArrow: <Arrow mirror />,
    nextArrow: <Arrow />
});

const isMoveToNextSessionBannerActive = (session, timeZone) => !isSessionEndsInMoreThan(session, NEXT_SESSION_BANNER_THRESHOLD, timeZone) && !isSessionEnded(session, timeZone);
const getUpcomingSessionsStatusMap = (sessions, timeZone) => sessions.reduce((statuses, session) => {
    if (!session.enableVirtualSession) {
        return statuses;
    }

    return {...statuses, [session.id]: !isSessionStartsInMorethan(session, 0, timeZone)};
}, {});

export const MoveToNextSessionBanner = ({event, user, session, eventUrls, siteConf, timeZone, upcomingSessions, fetchUpcomingSessions, setRecordUrl}) => {

    const [active, setActive] = useState(() => isMoveToNextSessionBannerActive(session, timeZone));
    const [sessionStatuses, setSessionStatuses] = useState(() => getUpcomingSessionsStatusMap(upcomingSessions, timeZone));

    useEffect(() => {
        if (active) {
            fetchUpcomingSessions(session, event.id, NEXT_SESSIONS_COUNT);
        }
    }, [active]);

    useInterval(() => {
        if (isMoveToNextSessionBannerActive(session, timeZone)) {
            setActive(true);
        }
    }, !active ? SESSION_UPDATE_INTERVAL : null, true);

    useInterval(() => {
        if (upcomingSessions.length) {
            setSessionStatuses(getUpcomingSessionsStatusMap(upcomingSessions, timeZone));
        }
    }, active ? NEXT_SESSION_STATUS_UPDATE_INTERVAL : null, false);

    if (!active || !upcomingSessions?.length) {
        return null;
    }

    return <div className='move-to-next-session-banner-container'>
        <BZCarousel
            className="move-to-next-session-banner"
            settings={getSliderSettings(upcomingSessions?.length)}
        >
            {upcomingSessions.map((item) => (
                <div key={item.id}>
                    <div className='move-to-next-session-item'>
                        <span className='next-session-status'>
                    Up Next
                            {sessionStatuses?.[item.id] ?
                                <span className='live-label'>
                                    <span className='circle-live-now'/>LIVE
                                </span> :
                                <span className='next-session-time'>({moment(item.startTime).format('hh:mmA')})</span>}
                            <LeftArrowIcon className='next-session-arrow'/>
                        </span>
                        <span className='next-session-title'>{item.title}</span>
                        <JoinLiveSessionButton
                            event={event}
                            me={user}
                            session={item}
                            eventUrls={eventUrls}
                            btnText="Join now"
                            showIcon={false}
                            btnClass='move-to-next-session-button'
                            siteConf={siteConf}
                            setRecordUrl={setRecordUrl}
                            setVirtualSessionDetails={setVirtualSessionDetails}
                        />
                    </div>

                </div>
            ))}
        </BZCarousel>
    </div>;
};

